import { render } from "./rec_goods.vue?vue&type=template&id=7eee06b8&scoped=true"
import script from "./rec_goods.vue?vue&type=script&lang=js"
export * from "./rec_goods.vue?vue&type=script&lang=js"

import "./rec_goods.vue?vue&type=style&index=0&id=7eee06b8&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eee06b8"]])

export default __exports__